/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import CardTitle from '@/checkout-instore-legacy/components/Commons/Elements/CardTitle'
import {
  dispatchSimpleError,
  getFullOrderId,
} from '@/checkout-instore-legacy/order/utils'
import { listOrdersGraphql } from '@/checkout-instore-legacy/order/service'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

import OrderTableCard from './OrderTableCard'
import OrderCardList from './OrderCardList'

const DEFAULT_PER_PAGE = 10

class LastOrders extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  onOrdersPageLoad = async ({
    startCursor = null,
    endCursor = null,
    perPage = DEFAULT_PER_PAGE,
    query = '',
  }) => {
    const paginationParams = endCursor
      ? {
          after: endCursor,
          first: perPage,
        }
      : startCursor
      ? {
          before: startCursor,
          last: perPage,
        }
      : {}

    try {
      return await listOrdersGraphql({
        query,
        ...paginationParams,
      })
    } catch (error) {
      dispatchSimpleError({
        dispatch: this.props.dispatch,
        errorTitle: this.props.intl.formatMessage({
          id: 'lastOrdersSearchError',
        }),
        error,
      })
    }
  }

  onOrderClick = (id) => {
    const orderId = getFullOrderId(id)
    this.props.router.push(
      `/orderplaced?orderId=${orderId}&printImmediately=false`
    )
  }

  render() {
    const ns = this.props.mediaQuery({ ns: true, s: false })
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <div
          data-testid="last-orders-container"
          className="overflow-auto h-100 min-w-100 bg-muted-5 pt7 pv7-ns pv8-l ph5-ns ph0-l"
        >
          <div className="mw8 center-all">
            <div className="pl5">
              <CardTitle
                i18nTextId="lastOrders"
                defaultType="heading-4"
                largeType="heading-2"
              />
            </div>
            {!ns && (
              <OrderCardList
                handlePageLoad={this.onOrdersPageLoad}
                handleOrderClick={this.onOrderClick}
              />
            )}
            {ns && (
              <OrderTableCard
                handlePageLoad={this.onOrdersPageLoad}
                handleOrderClick={this.onOrderClick}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

LastOrders.propTypes = {
  router: PropTypes.object,
  dispatch: PropTypes.func,
  intl: intlShape.isRequired,
  mediaQuery: PropTypes.any,
}

export default injectIntl(withRouter(withMediaQuery(LastOrders)))
